import { formatDecimal, formatNumber } from 'Util';

const Howto = ({ ctrTyp, data }) => {

	function renderingPrice(val) {
		if (ctrTyp === 1) {
			return (
				<strong>{formatNumber(val)}{val && '원'}</strong>
			)
		} else if (ctrTyp === 2) {
			return (
				<strong>{val && '$'}{formatDecimal(val, 2)}</strong>
			)
		}
	}

	return (
		<div className="chart chart1 chart_contnts">
			<div className="chart_view">
				<div className="in_chart_area">
					<div className="closing_price">{renderingPrice(data.PRICE)}</div>
					<div className="closing_price_point"><strong>전일종가</strong></div>
					<div className="resist point1"><span>1차 저항</span>{renderingPrice(data.RESISTANCE1)}</div>
					<div className="breakthrough"><span>돌파</span></div>
					<div className="resist point2"><span>2차 저항</span>{renderingPrice(data.RESISTANCE2)}</div>
					<div className="rise"><span>강한 상승</span></div>
					<div className="support point1">{renderingPrice(data.SUPPORT1)}<span>1차 지지</span></div>
					<div className="drop"><span>하락</span></div>
					<div className="support point2">{renderingPrice(data.SUPPORT2)}<span>2차 지지</span></div>
					<div className="strong_drop"><span>강한 하락</span></div>
				</div>
			</div>
			<div className="chart_view ver_bg">
				<div className="in_chart_area">
					<div className="in_chart_area_bg">
						<img src="/static/images/icon/bg_graph.png" alt="" />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Howto;
